import { ReactSelect } from "@interface48/form-controls";
import React from "react";
import { getSchemaOptions, getSchemaType } from "../../utils";
import { SelectWidgetProps } from "./models";

export const ReactSelectWidgetComponent = <T extends string | number>(props: SelectWidgetProps<T>) => {
  const {
    id,
    schema,
    placeholder,
    readonly,
    disabled,
    multiple,
    autofocus,
    value,
    formContext,
    options: uiOptions,
    processValue,
    onChange,
    onBlur,
  } = props;
  const { createOptions, multipleOptions, remoteOptions } = uiOptions;

  if (uiOptions.optionGroups) {
    throw Error("optionGroups not supported for ReactSelectWidget.");
  }

  const valueType = getSchemaType(schema) as "string" | "number";
  const emptyValue = multiple ? [uiOptions.emptyValue] : uiOptions.emptyValue;

  const handleBlur = (value: T | ReadonlyArray<T> | null | undefined, otherData?: any) => {
    if (onBlur) {
      onBlur(id, value, otherData);
    }
  };

  return (
    <ReactSelect
      id={id}
      label={schema.title}
      autofocus={autofocus}
      disabled={disabled || readonly}
      multiple={multiple}
      placeholder={placeholder}
      value={typeof value === "undefined" && emptyValue ? (emptyValue as T) : value}
      options={!remoteOptions ? getSchemaOptions<T>(schema) : undefined}
      optionGroups={uiOptions.optionGroups}
      remoteOptions={remoteOptions ? { ...remoteOptions, valueType } : undefined}
      createOptions={createOptions}
      multipleOptions={multipleOptions}
      getApiConfiguration={formContext && formContext.getApiConfiguration}
      processValue={processValue}
      sharedValidation={formContext.sharedValidation}
      onBlur={handleBlur as any}
      onChange={onChange as any}
    />
  );
};

export const ReactSelectWidget = ReactSelectWidgetComponent;
